// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-container[data-v-af269ebe]{position:relative;height:100%;width:100%}\n", ""]);
// Exports
module.exports = exports;
